import { http } from './config/config-receituario'

export default {
  /**
   * Consulta produto pelo número de registro
   * @param {string} token
   * @param {string|number} numeroRegistro
   */
  register: (token, numeroRegistro) => {
    return http.get(
      `newprod?numero_registro=${encodeURIComponent(numeroRegistro)}`,
      {
        headers: {
          'Authorization': token
        }
      }
    )
  },
  /**
   * Consulta dados do Agrofit sem salvar produto
   * @param {string} token
   * @param {string|number} numeroRegistro
   * @param {boolean} normalize
   */
  consulta: (token, numeroRegistro, normalize = true) => {
    return http.get(
      `newprod/consulta?numero_registro=${encodeURIComponent(numeroRegistro)}&normalize=${normalize}`,
      {
        headers: {
          'Authorization': token
        }
      }
    )
  },
  comparativoCulturas: (token, numeroRegistro) => {
    return http.get(
      `newprod/comparativo-culturas?numero_registro=${encodeURIComponent(numeroRegistro)}`,
      {
        headers: {
          'Authorization': token
        }
      }
    )
  }
}
